<div class="fusion-fullwidth fullwidth-box fusion-builder-row-1 fusion-parallax-none nonhundred-percent-fullwidth non-hundred-percent-height-scrolling"
    style='background-color: rgba(255,255,255,0);background-image: url("/wp-content/uploads/2021/01/ristrutturazione-interno.jpg");background-position: center center;background-repeat: no-repeat;padding-top:150px;padding-right:30px;padding-bottom:0px;padding-left:30px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;'>
    <div class="fusion-builder-row fusion-row ">
        <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-column-0 fusion-one-full fusion-column-first fusion-column-last 1_1"
            style='margin-top:0px;margin-bottom:0px;'>
            <div class="fusion-column-wrapper"
                style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">
                <style type="text/css">
                    @media only screen and (max-width:800px) {
                        .fusion-title.fusion-title-1 {
                            margin-top: 10px !important;
                            margin-bottom: 10px !important;
                        }
                    }
                </style>
                <div class="fusion-title title fusion-title-1 fusion-sep-none fusion-title-text fusion-title-size-one"
                    style="margin-top:0px;margin-bottom:10px;">
                    <h1 class="title-heading-left" style="margin:0;">
                        <h1 style="text-align: center;"><span style="color: #ffffff;">CREA UNA GARA</span></h1>
                        <h2 style="text-align: center;"><span style="color: #ffffff;">RICEVI PREVENTIVI PER IL TUO
                                PROSSIMO LAVORO</span></h2>
                    </h1>
                </div>
                <div class="fusion-sep-clear"></div>
                <div class="fusion-separator fusion-full-width-sep sep-none"
                    style="margin-left: auto;margin-right: auto;margin-top:100px;"></div>
                <div class="fusion-section-separator section-separator big-half-circle fusion-section-separator-with-offset"
                    style="padding:0;margin-left:calc( (100vw - 100% ) / -2 );margin-right:calc( (100vw - 100% ) / -2  );">
                    <svg class="fusion-big-half-circle-candy" xmlns="http://www.w3.org/2000/svg" version="1.1"
                        width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none"
                        style="fill:#ffffff;padding:0;">
                        <path d="M0 100 C40 0 60 0 100 100 Z"></path>
                    </svg></div>
                <div class="fusion-clearfix"></div>
            </div>
        </div>
    </div>
</div>
<style type="text/css">
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
        color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
        color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a {
        border-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
        border-color: #ffa626;
        background-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a,
    .fusion-fullwidth.fusion-builder-row-1 .fusion-date-and-formats .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
        color: #ffa626;
    }

    #main .fusion-fullwidth.fusion-builder-row-1 .post .blog-shortcode-post-title a:hover {
        color: #ffa626;
    }
</style>
<div class="fusion-fullwidth fullwidth-box fusion-builder-row-2 nonhundred-percent-fullwidth non-hundred-percent-height-scrolling"
    style='background-color: rgba(255,255,255,0);background-position: center center;background-repeat: no-repeat;padding-top:0px;padding-right:30px;padding-bottom:0px;padding-left:30px;'>
    <div class="fusion-builder-row fusion-row ">
        <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-column-1 fusion-one-full fusion-column-first fusion-column-last 1_1"
            style='margin-top:0px;margin-bottom:0px;'>
            <div class="fusion-column-wrapper"
                style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">
                <div class="fusion-text">
                    <h2 style="text-align: center;">SEGUI GLI STEP E CREA LA TUA GARA</h2>
                </div>
                <div class="fusion-sep-clear"></div>
                <div class="fusion-separator sep-single sep-solid"
                    style="border-color:#ffa626;border-top-width:2px;margin-left: auto;margin-right: auto;margin-top:0px;margin-bottom:30px;width:100%;max-width:206px;">
                </div>
                <div class="fusion-text">
                    <p style="text-align: center;">Compila all'interno di maschere predisposte i dati e carica gli 
                        allegati che ritieni necessari ad identificare, descrivere ed illustrare al meglio il lavoro che 
                        intendi appaltare.</p>
                </div>
                <div class="fusion-sep-clear"></div>
                <div class="fusion-separator fusion-full-width-sep sep-none"
                    style="margin-left: auto;margin-right: auto;margin-top:40px;"></div>
                <div class="fusion-clearfix"></div>
            </div>
        </div>
    </div>
</div>
<style type="text/css">
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
        color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
        color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-filters .fusion-filter.fusion-active a {
        border-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 .pagination .current {
        border-color: #ffa626;
        background-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-2 .fusion-filters .fusion-filter.fusion-active a,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-date-and-formats .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-2 .tooltip-shortcode {
        color: #ffa626;
    }

    #main .fusion-fullwidth.fusion-builder-row-2 .post .blog-shortcode-post-title a:hover {
        color: #ffa626;
    }
</style>
<div class="fusion-fullwidth fullwidth-box fusion-builder-row-3 nonhundred-percent-fullwidth non-hundred-percent-height-scrolling fusion-equal-height-columns"
    style='background-color: #ffffff;background-position: left top;background-repeat: no-repeat;padding-top:0px;padding-right:0px;padding-bottom:50px;padding-left:0px;border-top-width:0px;border-bottom-width:0px;border-color:#eae9e9;border-top-style:solid;border-bottom-style:solid;'>
    <div class="fusion-builder-row fusion-row ">
        <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-column-2 fusion-one-third fusion-column-first fusion-column-no-min-height 1_3"
            style='margin-top:0px;margin-bottom:0px;width:33.33%;width:calc(33.33% - ( ( 4% ) * 0.3333 ) );margin-right: 4%;'>
            <div class="fusion-column-wrapper"
                style="background-color:var(--ng-app-mid-grey-color);padding: 30px 30px 30px 30px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">
                <div class="fusion-column-content-centered">
                    <div class="fusion-column-content">
                        <div class="fusion-text">
                            <p><strong>STEP 1</strong></p>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator sep-single sep-solid"
                            style="border-color:#ffa626;border-top-width:2px;margin-top:0;margin-bottom:30px;width:100%;max-width:30%;">
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <div class="fusion-text">
                            <p><strong>Supporto alla compilazione della Gara:</strong></p>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <style type="text/css">
                            .fusion-accordian #accordion-15-1 .panel-title a .fa-fusion-box {
                                color: #ffffff;
                            }

                            .fusion-accordian #accordion-15-1 .panel-title a .fa-fusion-box:before {
                                font-size: 16px;
                                width: 16px;
                            }

                            .fusion-accordian #accordion-15-1 .panel-title a {
                                font-size: 18px;
                            }

                            .fusion-accordian #accordion-15-1 .fa-fusion-box {
                                background-color: #333333;
                                border-color: #333333;
                            }

                            .fusion-accordian #accordion-15-1 .panel-title a:hover,
                            #accordion-15-1 .fusion-toggle-boxed-mode:hover .panel-title a {
                                color: #ffa626;
                            }

                            .fusion-accordian #accordion-15-1 .panel-title .active .fa-fusion-box,
                            .fusion-accordian #accordion-15-1 .panel-title a:hover .fa-fusion-box {
                                background-color: #ffa626 !important;
                                border-color: #ffa626 !important;
                            }
                        </style>
                        <div class="accordian fusion-accordian">
                            <div class="panel-group" id="accordion-15-1" role="tablist">
                                <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                                aria-controls="827d3f3ac5f06d064" role="tab" data-toggle="collapse"
                                                data-parent="#accordion-15-1" data-target="#827d3f3ac5f06d064"
                                                href="#827d3f3ac5f06d064"><span class="fusion-toggle-icon-wrapper"
                                                    aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                                    class="fusion-toggle-heading">TITOLO DELLA GARA</span></a></h4>
                                    </div>
                                    <div id="827d3f3ac5f06d064" class="panel-collapse collapse ">
                                        <div class="panel-body toggle-content fusion-clearfix">
                                            <p>Max 150 caratteri. Es. Ristrutturazione Appartamento 150mq</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <style type="text/css">
                            .fusion-accordian #accordion-15-2 .panel-title a .fa-fusion-box {
                                color: #ffffff;
                            }

                            .fusion-accordian #accordion-15-2 .panel-title a .fa-fusion-box:before {
                                font-size: 16px;
                                width: 16px;
                            }

                            .fusion-accordian #accordion-15-2 .panel-title a {
                                font-size: 18px;
                            }

                            .fusion-accordian #accordion-15-2 .fa-fusion-box {
                                background-color: #333333;
                                border-color: #333333;
                            }

                            .fusion-accordian #accordion-15-2 .panel-title a:hover,
                            #accordion-15-2 .fusion-toggle-boxed-mode:hover .panel-title a {
                                color: #ffa626;
                            }

                            .fusion-accordian #accordion-15-2 .panel-title .active .fa-fusion-box,
                            .fusion-accordian #accordion-15-2 .panel-title a:hover .fa-fusion-box {
                                background-color: #ffa626 !important;
                                border-color: #ffa626 !important;
                            }
                        </style>
                        <div class="accordian fusion-accordian">
                            <div class="panel-group" id="accordion-15-2" role="tablist">
                                <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                                aria-controls="9134eb54d1c19ea37" role="tab" data-toggle="collapse"
                                                data-parent="#accordion-15-2" data-target="#9134eb54d1c19ea37"
                                                href="#9134eb54d1c19ea37"><span class="fusion-toggle-icon-wrapper"
                                                    aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                                    class="fusion-toggle-heading">DESCRIZIONE DELLA GARA</span></a>
                                        </h4>
                                    </div>
                                    <div id="9134eb54d1c19ea37" class="panel-collapse collapse ">
                                        <div class="panel-body toggle-content fusion-clearfix">
                                            <p>Max 500 caratteri. Descrivi sinteticamente l&#8217;oggetto della
                                                Gara.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <style type="text/css">
                            .fusion-accordian #accordion-15-3 .panel-title a .fa-fusion-box {
                                color: #ffffff;
                            }

                            .fusion-accordian #accordion-15-3 .panel-title a .fa-fusion-box:before {
                                font-size: 16px;
                                width: 16px;
                            }

                            .fusion-accordian #accordion-15-3 .panel-title a {
                                font-size: 18px;
                            }

                            .fusion-accordian #accordion-15-3 .fa-fusion-box {
                                background-color: #333333;
                                border-color: #333333;
                            }

                            .fusion-accordian #accordion-15-3 .panel-title a:hover,
                            #accordion-15-3 .fusion-toggle-boxed-mode:hover .panel-title a {
                                color: #ffa626;
                            }

                            .fusion-accordian #accordion-15-3 .panel-title .active .fa-fusion-box,
                            .fusion-accordian #accordion-15-3 .panel-title a:hover .fa-fusion-box {
                                background-color: #ffa626 !important;
                                border-color: #ffa626 !important;
                            }
                        </style>
                        <div class="accordian fusion-accordian">
                            <div class="panel-group" id="accordion-15-3" role="tablist">
                                <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                                aria-controls="15f3d1a988746e3d6" role="tab" data-toggle="collapse"
                                                data-parent="#accordion-15-3" data-target="#15f3d1a988746e3d6"
                                                href="#15f3d1a988746e3d6"><span class="fusion-toggle-icon-wrapper"
                                                    aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                                    class="fusion-toggle-heading">CATEGORIA DELLA GARA</span></a>
                                        </h4>
                                    </div>
                                    <div id="15f3d1a988746e3d6" class="panel-collapse collapse ">
                                        <div class="panel-body toggle-content fusion-clearfix">
                                            <p>Scegli una sola tra le categorie a tua disposizione: Costruzione,
                                                Ristrutturazione, Impianti, Scavi o Demolizioni.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <style type="text/css">
                            .fusion-accordian #accordion-15-4 .panel-title a .fa-fusion-box {
                                color: #ffffff;
                            }

                            .fusion-accordian #accordion-15-4 .panel-title a .fa-fusion-box:before {
                                font-size: 16px;
                                width: 16px;
                            }

                            .fusion-accordian #accordion-15-4 .panel-title a {
                                font-size: 18px;
                            }

                            .fusion-accordian #accordion-15-4 .fa-fusion-box {
                                background-color: #333333;
                                border-color: #333333;
                            }

                            .fusion-accordian #accordion-15-4 .panel-title a:hover,
                            #accordion-15-4 .fusion-toggle-boxed-mode:hover .panel-title a {
                                color: #ffa626;
                            }

                            .fusion-accordian #accordion-15-4 .panel-title .active .fa-fusion-box,
                            .fusion-accordian #accordion-15-4 .panel-title a:hover .fa-fusion-box {
                                background-color: #ffa626 !important;
                                border-color: #ffa626 !important;
                            }
                        </style>
                        <div class="accordian fusion-accordian">
                            <div class="panel-group" id="accordion-15-4" role="tablist">
                                <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                                aria-controls="de4b81d776d6073bd" role="tab" data-toggle="collapse"
                                                data-parent="#accordion-15-4" data-target="#de4b81d776d6073bd"
                                                href="#de4b81d776d6073bd"><span class="fusion-toggle-icon-wrapper"
                                                    aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                                    class="fusion-toggle-heading">PROVINCIA</span></a></h4>
                                    </div>
                                    <div id="de4b81d776d6073bd" class="panel-collapse collapse ">
                                        <div class="panel-body toggle-content fusion-clearfix">
                                            <p>Provincia del comune in cui si trova l&#8217;immobile, terreno&#8230; oggetto della
                                                gara</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <style type="text/css">
                            .fusion-accordian #accordion-15-5 .panel-title a .fa-fusion-box {
                                color: #ffffff;
                            }

                            .fusion-accordian #accordion-15-5 .panel-title a .fa-fusion-box:before {
                                font-size: 16px;
                                width: 16px;
                            }

                            .fusion-accordian #accordion-15-5 .panel-title a {
                                font-size: 18px;
                            }

                            .fusion-accordian #accordion-15-5 .fa-fusion-box {
                                background-color: #333333;
                                border-color: #333333;
                            }

                            .fusion-accordian #accordion-15-5 .panel-title a:hover,
                            #accordion-15-5 .fusion-toggle-boxed-mode:hover .panel-title a {
                                color: #ffa626;
                            }

                            .fusion-accordian #accordion-15-5 .panel-title .active .fa-fusion-box,
                            .fusion-accordian #accordion-15-5 .panel-title a:hover .fa-fusion-box {
                                background-color: #ffa626 !important;
                                border-color: #ffa626 !important;
                            }
                        </style>
                        <div class="accordian fusion-accordian">
                            <div class="panel-group" id="accordion-15-5" role="tablist">
                                <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                                aria-controls="b5ace178cc67d63ae" role="tab" data-toggle="collapse"
                                                data-parent="#accordion-15-5" data-target="#b5ace178cc67d63ae"
                                                href="#b5ace178cc67d63ae"><span class="fusion-toggle-icon-wrapper"
                                                    aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                                    class="fusion-toggle-heading">DATA PRESUNTA DI INIZIO E FINE
                                                    LAVORI</span></a></h4>
                                    </div>
                                    <div id="b5ace178cc67d63ae" class="panel-collapse collapse ">
                                        <div class="panel-body toggle-content fusion-clearfix">
                                            <p>Seleziona le date in cui vorresti dare inizio ai lavori e la data
                                                entro cui auspichi debbano terminare.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fusion-sep-clear"></div>
                        <div class="fusion-separator fusion-full-width-sep sep-none"
                            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                        <style type="text/css">
                            .fusion-accordian #accordion-15-6 .panel-title a .fa-fusion-box {
                                color: #ffffff;
                            }

                            .fusion-accordian #accordion-15-6 .panel-title a .fa-fusion-box:before {
                                font-size: 16px;
                                width: 16px;
                            }

                            .fusion-accordian #accordion-15-6 .panel-title a {
                                font-size: 18px;
                            }

                            .fusion-accordian #accordion-15-6 .fa-fusion-box {
                                background-color: #333333;
                                border-color: #333333;
                            }

                            .fusion-accordian #accordion-15-6 .panel-title a:hover,
                            #accordion-15-6 .fusion-toggle-boxed-mode:hover .panel-title a {
                                color: #ffa626;
                            }

                            .fusion-accordian #accordion-15-6 .panel-title .active .fa-fusion-box,
                            .fusion-accordian #accordion-15-6 .panel-title a:hover .fa-fusion-box {
                                background-color: #ffa626 !important;
                                border-color: #ffa626 !important;
                            }
                        </style>
                        <div class="accordian fusion-accordian">
                            <div class="panel-group" id="accordion-15-6" role="tablist">
                                <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                                aria-controls="42f7c3db16e8227b8" role="tab" data-toggle="collapse"
                                                data-parent="#accordion-15-6" data-target="#42f7c3db16e8227b8"
                                                href="#42f7c3db16e8227b8"><span class="fusion-toggle-icon-wrapper"
                                                    aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                                    class="fusion-toggle-heading">CREA LA GARA</span></a></h4>
                                    </div>
                                    <div id="42f7c3db16e8227b8" class="panel-collapse collapse ">
                                        <div class="panel-body toggle-content fusion-clearfix">
                                            <p>Cliccando &#8220;Crea la Gara&#8221; non determinerai la sua
                                                pubblicazione. Salverai quanto inserito e procederai alla tua
                                                registrazione su Skimming, se non ancora effettuata.</p>
                                            <p>Quanto inserito allo Step 1 sarà a tua disposizione nella tua area
                                                riservata, dove potrai terminare l&#8217;inserimento delle
                                                informazioni e, successivamente, pubblicare la Gara.</p>
                                            <p>Prima della pubblicazione potrai modificare quanto inserito in Step
                                                1.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fusion-clearfix"></div>
            </div>
        </div>
        <div class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-column-3 fusion-two-third fusion-column-last fusion-column-no-min-height 2_3"
            style='margin-top:0px;margin-bottom:0px;width:66.66%;width:calc(66.66% - ( ( 4% ) * 0.6666 ) );'>
            <div class="fusion-column-wrapper"
                style="background-color:var(--ng-app-mid-grey-color);padding: 30px 30px 50px 30px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">
                <div class="fusion-column-content-centered">
                    <form [formGroup]="newTenderForm" id="new-tender-appform">
                        <div class="fusion-column-content">
                            <ul class="fusion-checklist fusion-checklist-1" style="font-size:14px;line-height:23.8px;">
                                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-info fas"
                                            style="color:#717171;"></i></span>
                                    <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                        <p>TITOLO DELLA GARA</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="fusion-button-wrapper fusion-align-block">
                                <style type="text/css">
                                    .fusion-button.button-1 .fusion-button-text,
                                    .fusion-button.button-1 i {
                                        color: #a5a5a5;
                                    }

                                    .fusion-button.button-1 .fusion-button-icon-divider {
                                        border-color: #a5a5a5;
                                    }

                                    .fusion-button.button-1:hover .fusion-button-text,
                                    .fusion-button.button-1:hover i,
                                    .fusion-button.button-1:focus .fusion-button-text,
                                    .fusion-button.button-1:focus i,
                                    .fusion-button.button-1:active .fusion-button-text,
                                    .fusion-button.button-1:active {
                                        color: #ffffff;
                                    }

                                    .fusion-button.button-1:hover .fusion-button-icon-divider,
                                    .fusion-button.button-1:hover .fusion-button-icon-divider,
                                    .fusion-button.button-1:active .fusion-button-icon-divider {
                                        border-color: #ffffff;
                                    }

                                    .fusion-button.button-1:hover,
                                    .fusion-button.button-1:focus,
                                    .fusion-button.button-1:active {
                                        border-color: #ffffff;
                                    }

                                    .fusion-button.button-1 {
                                        border-color: #333333;
                                        border-radius: 0px;
                                    }

                                    .fusion-button.button-1 {
                                        background: #ffffff;
                                    }

                                    .fusion-button.button-1:hover,
                                    .button-1:focus,
                                    .fusion-button.button-1:active {
                                        background: #ffffff;
                                    }
                                </style>
                                <input class="ng-app-input" type="text" placeholder="Titolo" formControlName="title" (click)="resetError()" required maxlength="150">
                                <div [ngStyle]="{'visibility':newTenderForm.get('title').valid || newTenderForm.get('title').pristine ? 'hidden':'visible'}" class="ng-alert">
                                    Inserire un titolo per la gara.
                                </div>
                            </div>
                            <div class="fusion-sep-clear"></div>
                            <div class="fusion-separator fusion-full-width-sep sep-none"
                                style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
                            <ul class="fusion-checklist fusion-checklist-2" style="font-size:14px;line-height:23.8px;">
                                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-align-center fas"
                                            style="color:#717171;"></i></span>
                                    <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                        <p>BREVE DESCRIZIONE</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="fusion-button-wrapper fusion-align-block">
                                <style type="text/css">
                                    .fusion-button.button-2 .fusion-button-text,
                                    .fusion-button.button-2 i {
                                        color: #a5a5a5;
                                    }

                                    .fusion-button.button-2 .fusion-button-icon-divider {
                                        border-color: #a5a5a5;
                                    }

                                    .fusion-button.button-2:hover .fusion-button-text,
                                    .fusion-button.button-2:hover i,
                                    .fusion-button.button-2:focus .fusion-button-text,
                                    .fusion-button.button-2:focus i,
                                    .fusion-button.button-2:active .fusion-button-text,
                                    .fusion-button.button-2:active {
                                        color: #ffffff;
                                    }

                                    .fusion-button.button-2:hover .fusion-button-icon-divider,
                                    .fusion-button.button-2:hover .fusion-button-icon-divider,
                                    .fusion-button.button-2:active .fusion-button-icon-divider {
                                        border-color: #ffffff;
                                    }

                                    .fusion-button.button-2:hover,
                                    .fusion-button.button-2:focus,
                                    .fusion-button.button-2:active {
                                        border-color: #ffffff;
                                    }

                                    .fusion-button.button-2 {
                                        border-color: #333333;
                                        border-radius: 0px;
                                    }

                                    .fusion-button.button-2 {
                                        background: #ffffff;
                                    }

                                    .fusion-button.button-2:hover,
                                    .button-2:focus,
                                    .fusion-button.button-2:active {
                                        background: #ffffff;
                                    }
                                </style>
                                <textarea class="ng-app-input" type="text" placeholder="Descrizione" formControlName="description" (click)="resetError()" required required maxlength="500"></textarea>
                                <div [ngStyle]="{'visibility':newTenderForm.get('description').valid || newTenderForm.get('description').pristine ? 'hidden':'visible'}" class="ng-alert">
                                    Inserire una descrizione per la gara.
                                </div>
                            </div>
                            <div class="fusion-sep-clear"></div>
                            <div class="fusion-separator fusion-full-width-sep sep-none"
                                style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
                            <ul class="fusion-checklist fusion-checklist-3" style="font-size:14px;line-height:23.8px;">
                                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-building fas"
                                            style="color:#717171;"></i></span>
                                    <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                        <p>CATEGORIA</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="fusion-builder-row fusion-builder-row-inner fusion-row ">
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-nested-column-1 fusion-one-fifth fusion-column-first 1_5"
                                    style='margin-top: 0px;margin-bottom: 0px;width:20%;width:calc(20% - ( ( 4% + 4% + 4% + 4% ) * 0.2 ) );margin-right:4%;'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-1 ng-category-box {{constructionBox}}"
                                        style="padding: 5px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="" (click)="selectConstruction()">
                                        <span class="fusion-imageframe imageframe-none imageframe-1 hover-type-none"><img
                                                src="/wp-content/uploads/2015/12/Costruzione-300x300-1.png"
                                                width="300" height="300" alt="" title="Costruzione 300&#215;300"
                                                class="img-responsive wp-image-1308" /></span>

                                    </div>
                                </div>
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-nested-column-2 fusion-one-fifth 1_5"
                                    style='margin-top: 0px;margin-bottom: 0px;width:20%;width:calc(20% - ( ( 4% + 4% + 4% + 4% ) * 0.2 ) );margin-right:4%;'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-2 ng-category-box {{renovationBox}}"
                                        style="padding: 5px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="" (click)="selectRenovation()">
                                        <span class="fusion-imageframe imageframe-none imageframe-2 hover-type-none"><img
                                                src="/wp-content/uploads/2020/02/Ristrutturazioni-300x300-1.png"
                                                width="300" height="300" alt="" title="Ristrutturazioni 300&#215;300"
                                                class="img-responsive wp-image-1307" /></span>

                                    </div>
                                </div>
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-nested-column-3 fusion-one-fifth 1_5"
                                    style='margin-top: 0px;margin-bottom: 0px;width:20%;width:calc(20% - ( ( 4% + 4% + 4% + 4% ) * 0.2 ) );margin-right:4%;'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-3 ng-category-box {{systemBox}}"
                                        style="padding: 5px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="" (click)="selectSystem()">
                                        <span class="fusion-imageframe imageframe-none imageframe-3 hover-type-none"><img
                                                src="/wp-content/uploads/2015/06/Impianti-300x300-1.png"
                                                width="300" height="300" alt="" title="Impianti 300&#215;300"
                                                class="img-responsive wp-image-1310" /></span>

                                    </div>
                                </div>
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-nested-column-4 fusion-one-fifth 1_5"
                                    style='margin-top: 0px;margin-bottom: 0px;width:20%;width:calc(20% - ( ( 4% + 4% + 4% + 4% ) * 0.2 ) );margin-right:4%;'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-4 ng-category-box {{excavationBox}}"
                                        style="padding: 5px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="" (click)="selectExcavation()">
                                        <span class="fusion-imageframe imageframe-none imageframe-4 hover-type-none"><img
                                                src="/wp-content/uploads/2015/12/Scavi-300x300-1.png"
                                                width="300" height="300" alt="" title="Scavi 300&#215;300"
                                                class="img-responsive wp-image-1309" /></span>

                                    </div>
                                </div>
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-nested-column-5 fusion-one-fifth fusion-column-last 1_5"
                                    style='margin-top: 0px;margin-bottom: 0px;width:20%;width:calc(20% - ( ( 4% + 4% + 4% + 4% ) * 0.2 ) );'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-5 ng-category-box {{demolitionBox}}"
                                        style="padding: 5px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="" (click)="selectDemolition()">
                                        <span class="fusion-imageframe imageframe-none imageframe-5 hover-type-none"><img
                                                src="/wp-content/uploads/2015/06/Demolizioni-300x300-1.png"
                                                width="300" height="300" alt="" title="Demolizioni 300&#215;300"
                                                class="img-responsive wp-image-1311" /></span>

                                    </div>
                                </div>
                            </div>
                            <div [ngStyle]="{'visibility':categoryError === 'no_error' ? 'hidden':'visible'}" class="ng-alert">
                                {{categoryError}}
                            </div>
                            <div class="fusion-sep-clear"></div>
                            <div class="fusion-separator fusion-full-width-sep sep-none"
                                style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
                            <ul class="fusion-checklist fusion-checklist-4" style="font-size:14px;line-height:23.8px;">
                                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-map-marker-alt fas"
                                            style="color:#717171;"></i></span>
                                    <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                        <p>PROVINCIA</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="fusion-button-wrapper fusion-align-block">
                                <style type="text/css">
                                    .fusion-button.button-3 .fusion-button-text,
                                    .fusion-button.button-3 i {
                                        color: #a5a5a5;
                                    }

                                    .fusion-button.button-3 .fusion-button-icon-divider {
                                        border-color: #a5a5a5;
                                    }

                                    .fusion-button.button-3:hover .fusion-button-text,
                                    .fusion-button.button-3:hover i,
                                    .fusion-button.button-3:focus .fusion-button-text,
                                    .fusion-button.button-3:focus i,
                                    .fusion-button.button-3:active .fusion-button-text,
                                    .fusion-button.button-3:active {
                                        color: #ffffff;
                                    }

                                    .fusion-button.button-3:hover .fusion-button-icon-divider,
                                    .fusion-button.button-3:hover .fusion-button-icon-divider,
                                    .fusion-button.button-3:active .fusion-button-icon-divider {
                                        border-color: #ffffff;
                                    }

                                    .fusion-button.button-3:hover,
                                    .fusion-button.button-3:focus,
                                    .fusion-button.button-3:active {
                                        border-color: #ffffff;
                                    }

                                    .fusion-button.button-3 {
                                        border-color: #333333;
                                        border-radius: 0px;
                                    }

                                    .fusion-button.button-3 {
                                        background: #ffffff;
                                    }

                                    .fusion-button.button-3:hover,
                                    .button-3:focus,
                                    .fusion-button.button-3:active {
                                        background: #ffffff;
                                    }
                                </style>
                                <select formControlName="provinceCode" required (click)="resetError()">
                                    <option [ngValue]="null" ></option>
                                    <option [ngValue]="province.code" *ngFor="let province of provinces">{{province.description}}</option>
                                </select>
                                <div [ngStyle]="{'visibility':newTenderForm.get('provinceCode').valid || newTenderForm.get('provinceCode').pristine ? 'hidden':'visible'}"class="ng-alert">
                                    La provincia è obbligatoria.
                                </div>
                            </div>
                            <div class="fusion-sep-clear"></div>
                            <div class="fusion-separator fusion-full-width-sep sep-none"
                                style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
                            <ul class="fusion-checklist fusion-checklist-5" style="font-size:14px;line-height:23.8px;">
                                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-calendar-alt fas"
                                            style="color:#717171;"></i></span>
                                    <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                        <p>DATA INIZIO E FINE LAVORI (Presunte)</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="fusion-builder-row fusion-builder-row-inner fusion-row ">
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-6 fusion-one-half fusion-column-first 1_2"
                                    style='margin-top: 0px;margin-bottom: 0px;width:50%;width:calc(50% - ( ( 4% ) * 0.5 ) );margin-right:4%;'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-6"
                                        style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="">
                                        <div class="fusion-button-wrapper fusion-align-block">
                                            <style type="text/css">
                                                .fusion-button.button-4 .fusion-button-text,
                                                .fusion-button.button-4 i {
                                                    color: #c4c4c4;
                                                }

                                                .fusion-button.button-4 .fusion-button-icon-divider {
                                                    border-color: #c4c4c4;
                                                }

                                                .fusion-button.button-4:hover .fusion-button-text,
                                                .fusion-button.button-4:hover i,
                                                .fusion-button.button-4:focus .fusion-button-text,
                                                .fusion-button.button-4:focus i,
                                                .fusion-button.button-4:active .fusion-button-text,
                                                .fusion-button.button-4:active {
                                                    color: #ffffff;
                                                }

                                                .fusion-button.button-4:hover .fusion-button-icon-divider,
                                                .fusion-button.button-4:hover .fusion-button-icon-divider,
                                                .fusion-button.button-4:active .fusion-button-icon-divider {
                                                    border-color: #ffffff;
                                                }

                                                .fusion-button.button-4:hover,
                                                .fusion-button.button-4:focus,
                                                .fusion-button.button-4:active {
                                                    border-color: #ffffff;
                                                }

                                                .fusion-button.button-4 {
                                                    border-color: #333333;
                                                    border-radius: 0px;
                                                }

                                                .fusion-button.button-4 {
                                                    background: #ffffff;
                                                }

                                                .fusion-button.button-4:hover,
                                                .button-4:focus,
                                                .fusion-button.button-4:active {
                                                    background: #ffffff;
                                                }
                                            </style>
                                            <div class="fusion-button button-flat fusion-button-default-size button-custom button-4 fusion-button-span-yes fusion-button-default-type {{startDateAlert}}">
                                                <span (click)="startDatePicker.open()"
                                                    class="fusion-button-icon-divider button-icon-divider-left"><i
                                                        class="fa-calendar-alt fas" style="color: #c4c4c4 !important"></i></span>
                                                <input matInput [matDatepicker]="startDatePicker" placeholder="Data inizio" formControlName="startDate" 
                                                    style="border-bottom: none !important; padding-left: 30px !important; padding-bottom: 3px !important; padding-top: 3px !important;">
                                                <mat-datepicker #startDatePicker></mat-datepicker>
                                            </div>
                                            <div [ngStyle]="{'visibility':newTenderForm.get('startDate').valid || newTenderForm.get('startDate').pristine ? 'hidden':'visible'}" class="ng-alert">
                                                Scegliere una data di inizio.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-7 fusion-one-half fusion-column-last 1_2"
                                    style='margin-top: 0px;margin-bottom: 0px;width:50%;width:calc(50% - ( ( 4% ) * 0.5 ) );'>
                                    <div class="fusion-column-wrapper fusion-column-wrapper-7"
                                        style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                                        data-bg-url="">
                                        <div class="fusion-button-wrapper fusion-align-block">
                                            <style type="text/css">
                                                .fusion-button.button-5 .fusion-button-text,
                                                .fusion-button.button-5 i {
                                                    color: #c4c4c4;
                                                }

                                                .fusion-button.button-5 .fusion-button-icon-divider {
                                                    border-color: #c4c4c4;
                                                }

                                                .fusion-button.button-5:hover .fusion-button-text,
                                                .fusion-button.button-5:hover i,
                                                .fusion-button.button-5:focus .fusion-button-text,
                                                .fusion-button.button-5:focus i,
                                                .fusion-button.button-5:active .fusion-button-text,
                                                .fusion-button.button-5:active {
                                                    color: #ffffff;
                                                }

                                                .fusion-button.button-5:hover .fusion-button-icon-divider,
                                                .fusion-button.button-5:hover .fusion-button-icon-divider,
                                                .fusion-button.button-5:active .fusion-button-icon-divider {
                                                    border-color: #ffffff;
                                                }

                                                .fusion-button.button-5:hover,
                                                .fusion-button.button-5:focus,
                                                .fusion-button.button-5:active {
                                                    border-color: #ffffff;
                                                }

                                                .fusion-button.button-5 {
                                                    border-color: #333333;
                                                    border-radius: 0px;
                                                }

                                                .fusion-button.button-5 {
                                                    background: #ffffff;
                                                }

                                                .fusion-button.button-5:hover,
                                                .button-5:focus,
                                                .fusion-button.button-5:active {
                                                    background: #ffffff;
                                                }
                                            </style>
                                            <div class="fusion-button button-flat fusion-button-default-size button-custom button-4 fusion-button-span-yes fusion-button-default-type {{endDateAlert}}">
                                                <span
                                                    class="fusion-button-icon-divider button-icon-divider-left" (click)="endDatePicker.open()"><i
                                                        class="fa-calendar-alt fas" style="color: #c4c4c4 !important"></i></span>
                                                <input matInput [matDatepicker]="endDatePicker" placeholder="Data fine" formControlName="endDate" 
                                                    style="border-bottom: none !important; padding-left: 30px !important; padding-bottom: 3px !important; padding-top: 3px !important;">
                                                <mat-datepicker #endDatePicker></mat-datepicker>
                                            </div>
                                            <div [ngStyle]="{'visibility':newTenderForm.get('endDate').valid || newTenderForm.get('endDate').pristine ? 'hidden':'visible'}" class="ng-alert">
                                                Scegliere una data di fine posteriore a quella di inizio.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="fusion-sep-clear"></div>
                            <div class="fusion-separator fusion-full-width-sep sep-none"
                                style="margin-left: auto;margin-right: auto;margin-top:10PX;"></div>
                            <div [ngStyle]="{'visibility':error === 'no_error' ? 'hidden':'visible'}" class="ng-alert">
                                {{error}}
                            </div>
                            <div class="ng-spinner">
                                <img *ngIf="loading" src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"/>
                            </div>
                            <div class="fusion-sep-clear"></div>
                            <div class="fusion-separator fusion-full-width-sep sep-none"
                                style="margin-left: auto;margin-right: auto;margin-top:20PX;"></div>
                            <div class="fusion-button-wrapper fusion-aligncenter">
                                <style type="text/css">
                                    .fusion-button.button-6 {
                                        border-radius: 0px;
                                    }
                                </style><a (click)="newTenderSubmitHandler()" appInvalidControlScroll
                                    class="fusion-button button-flat fusion-button-default-size button-default button-6 fusion-button-default-span fusion-button-default-type"
                                    target="_self"><span
                                        class="fusion-button-text">CREA LA GARA</span></a>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="fusion-clearfix"></div>
            </div>
        </div>
    </div>
</div>
<style type="text/css">
    .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
        color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
        color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-3 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-3 .fusion-filters .fusion-filter.fusion-active a {
        border-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-3 .pagination .current {
        border-color: #ffa626;
        background-color: #ffa626;
    }

    .fusion-fullwidth.fusion-builder-row-3 .fusion-filters .fusion-filter.fusion-active a,
    .fusion-fullwidth.fusion-builder-row-3 .fusion-date-and-formats .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-3 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-3 .tooltip-shortcode {
        color: #ffa626;
    }

    #main .fusion-fullwidth.fusion-builder-row-3 .post .blog-shortcode-post-title a:hover {
        color: #ffa626;
    }
</style>